module.exports = __webpack_public_path__ + "static/media/responsive_bco.ded7456a.svg";